import {UUID} from '../../../shared/types/uuid.type';
import {createReducer, on} from '@ngrx/store';
import * as RecordsActions from '../actions/records.actions';
import {DvrRecord, DvrRecordStatus} from '../../../services/api/dvr/dvr.model';
import {Utils} from '../../../services/Utils';

export const recordsFeatureKey = 'records';

export interface State {
  record: DvrRecord[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: [],
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(RecordsActions.loadRecords, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(RecordsActions.loadRecordsSuccess, (_state, action) => ({
    record: Utils.sortArrayByDate(action.data, 'createdAt'),
    error: null,
    loaded: true,
    loading: false
  })),
  on(RecordsActions.loadRecordsFailure, (_state, action) => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(RecordsActions.recordCreated, (state: State, action: { record: DvrRecord }) => ({
    record: Utils.sortArrayByDate([...state.record, action.record], 'createdAt'),
    error: null,
    loaded: true,
    loading: false
  })),
  on(RecordsActions.recordUpdated, (state: State, action: { record: DvrRecord }) => {
    const recordId: UUID = action.record.id;
    const updatedRecords: DvrRecord[] = state.record
      .map((record: DvrRecord): DvrRecord => {
          if (record.id === recordId) {
            return {...record, ...action.record};
          }

          return record;
        }
      );
    return {
      record: Utils.sortArrayByDate(updatedRecords, 'createdAt'),
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(RecordsActions.recordDeleted, (state: State, action: { recordId: UUID }) => {
    const recordId: UUID = action.recordId;
    const updatedRecords: DvrRecord[] = state.record
      .filter((record: DvrRecord): boolean => record.id !== recordId);
    return {
      record: Utils.sortArrayByDate(updatedRecords, 'createdAt'),
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(RecordsActions.recordUpdated, (state: State, action: { record: DvrRecord }): State => {
    const updatedRecord: DvrRecord = action.record;
    const updatedRecordId: UUID = updatedRecord.id;

    const records: DvrRecord[] = state.record
      .map((record: DvrRecord): DvrRecord => {
        const id: UUID = record.id;
        if (updatedRecordId === id) {
          return updatedRecord;
        }

        return record;
      });

    return {
      record: records,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(RecordsActions.manyRecordsStatusUpdated, (state: State, action: { ids: UUID[], status: DvrRecordStatus }): State => {
    const updatedStatus: DvrRecordStatus = action.status;
    const updatedRecordIds: UUID[] = action.ids;

    const records: DvrRecord[] = state.record
      .map((record: DvrRecord): DvrRecord => {
        const id: UUID = record.id;

        const index: number = updatedRecordIds.indexOf(id);
        if (index !== -1) {
          return {
            ...record,
            status: updatedStatus
          };
        }

        return record;
      });

    return {
      record: records,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(RecordsActions.manyRecordsDeleted, (state: State, action: { ids: UUID[] }): State => {
    const records: DvrRecord[] = state.record
      .filter((record: DvrRecord): boolean => {
        const id: UUID = record.id;
        return !action.ids.includes(id);
      });

    return {
      record: records,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(RecordsActions.clearRecordsState, () => ({
    record: [],
    error: null,
    loaded: false,
    loading: false
  }))
);
